const addHorizontalRule = (editor) => {
  editor.chain().focus().setHorizontalRule().run();
};

export default {
  'horizontalrule:add': addHorizontalRule,
};
